import { Checkbox } from "@/components/ui/checkbox";
import { Link } from "react-router-dom";
import { t } from "@/lib/i18n";

/**
 * TCPA / A2P 10DLC-compliant SMS consent block.
 *
 * Requirements met:
 * - Checkbox is NOT pre-checked.
 * - Business name (Gens Realty) is disclosed.
 * - Purpose, frequency (varies), msg&data rates, STOP/HELP included.
 * - Explicit "Consent is not a condition of purchase".
 * - Links to Terms of Service AND Privacy Policy directly beside the checkbox.
 * - Affirmative label ("Yes, sign me up — text me updates about my request.").
 */
export default function SmsConsent({ checked, onCheckedChange, lang }) {
  const id = "sms-consent-checkbox";
  return (
    <div
      className="flex items-start gap-3 p-3 rounded-lg bg-[#F9F6F0] border border-[#EBE4D3]"
      data-testid="sms-consent-block"
    >
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={onCheckedChange}
        className="mt-0.5 border-[#1E3B2F] data-[state=checked]:bg-[#C25934] data-[state=checked]:border-[#C25934]"
        data-testid="sms-consent-checkbox"
      />
      <div className="space-y-1.5 text-[#1F1F1F] leading-snug">
        <label
          htmlFor={id}
          className="cursor-pointer select-none text-xs font-semibold leading-tight block"
        >
          {t(lang, "smsConsentLabel")}
        </label>
        <div className="text-[11px] text-[#6B7280]">{t(lang, "smsConsentBody")}</div>
        <div className="text-[11px] text-[#6B7280]">
          {t(lang, "smsConsentReviewPrefix")}{" "}
          <Link
            to="/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-[#1E3B2F] hover:text-[#C25934]"
            data-testid="sms-consent-terms-link"
          >
            {t(lang, "termsOfService")}
          </Link>{" "}
          {t(lang, "smsConsentAnd")}{" "}
          <Link
            to="/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-[#1E3B2F] hover:text-[#C25934]"
            data-testid="sms-consent-privacy-link"
          >
            {t(lang, "privacyPolicy")}
          </Link>
          .
        </div>
      </div>
    </div>
  );
}
